<div class="card-button" [class.disabled]="disabled">
  <div class="text-container">
    <div *ngIf="icon || dsIcon" class="icon-container" [ngClass]="'icon-container-' + type">
      <mat-icon *ngIf="icon && !dsIcon" class="material-symbols-outlined icon">{{ icon }}</mat-icon>
      <ds-icon *ngIf="dsIcon" [icon]="dsIcon" class="icon"></ds-icon>
    </div>
    <span class="label" *ngIf="label">{{ label }}</span>
  </div>
  <ds-button
    color="primary"
    [size]="btnSize$ | async"
    [label]="labelButton"
    [loading]="loading"
    [loadingText]="loadingText"
    (click)="onButtonClick()"
  ></ds-button>
</div>
